import { ApiService, toFormData, toModels } from '~/shared/api'
import { ArticleComment } from '~/models/articles'
import { API_PREFIX } from '~/shared/const/request-services'

export class ArticleCommentsService extends ApiService {
  getComments(slug: string): Promise<ArticleComment[]> {
    return this.http
      .request({ url: `${API_PREFIX}/news/${slug}/comments` })
      .then(toModels(ArticleComment))
  }

  async addComment(slug: string, text: string, images: File[] = []): Promise<void> {
    await this.http.request({
      data: images.length > 0 ? toFormData({ text, images }) : { text },
      method: 'POST',
      url: `${API_PREFIX}/news/${slug}/comments/add`,
    })
  }
}
